<template>
    <div class="flex sm:items-center sm:justify-center sm:flex-row flex-col w-full">
        <input type="text" v-model="url" @click="error = false"
            class="sm:h-14 h-10 w-full bg-white sm:text-lg text-base px-6 border outline-none  sm:border-r-0 focus:border-none focus:drop-shadow-lg"
            :class="{ 'border-danger border-dashed': error, 'border-gray-300': !error }" placeholder="URL image">
        <button @click="submitUrl()" :class="{ 'disabled:opacity-80 disabled:cursor-not-allowed': loading }"
            :disabled="loading"
            class="w-32 sm:h-14 h-10 sm:mt-0 mt-4 flex-shrink-0 bg-success border border-success flex items-center justify-center text-white text-base sm:text-lg font-semibold">
            <IconsLoadingDecorator v-if="loading || scanner.scanning" class="text-white w-5 h-5" />
            <template v-if="scanner.scanning">
                {{ $t('scanning') }}
            </template>
            <template v-else>
                {{ $t('decode') }}
            </template>
        </button>
    </div>
</template>
<script lang="ts" setup>
// trest https://i.imgur.com/cfanr9l.png
import { processUrl } from "~/config/misc/scanner";
import { useScanner } from "~~/stores/scanner";
interface ResponseScanner {
    content: string;
    name?: string;
    file?: string;
    type?: string
}
const scanner = useScanner()
const url = ref('')
const utils = useUtils()
const error = ref(false)
const loading = ref(false)
const submitUrl = () => {
    if (url.value && /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/gm.test(url.value)) {
        error.value = false
        DecoderUrl(url.value)
        return
    }
    error.value = true
}
const DecoderUrl = async (url: string) => {
    loading.value = true
    const response = await useFetch('/api/file', {
        headers: { "Content-type": "application/json" },
        method: 'POST',
        body: {
            url
        }
    })



    runDecoder('data:image/png;base64,' + response.data.value)
    loading.value = false

}

const runDecoder = async (base64: string) => {
    scanner.startScanning()
    const resultPromises = [processUrl(base64)];
    Promise.all(resultPromises).then((values) => {
        var data: Array<ResponseScanner> = []
        values.forEach((item, index) => {
            const { content } = item
            data.push({
                content,
                file: base64,
                name: url.value
            })
        })
        scanner.response = data;
        scanner.openModal()
        scanner.scanning = false
    }).catch(err => {
        console.log(err);
        scanner.scanning = false
    });
}
</script>